import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import { useShowToast } from '@/design_system/Toast';
import { useStartExchange } from '@/models/article';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import { ExchangeDuration } from '../ExchangeDuration/ExchangeDuration';

import { ActionSeparator } from './ActionSeparator';
import { ArticleActionProps } from './ArticleActions';

export const StartArticleExchangeAction = ({ article, onActionDone }: ArticleActionProps) => {
  const { t } = useLingui();
  const showToast = useShowToast();
  const { workflow } = useRequestContext();

  const { mutateAsync: startExchange, isPending: isStartExchangePending } = useStartExchange({
    articleId: article.id,
  });

  const confirmStartExchange = async () => {
    try {
      await startExchange();
      onActionDone();
    } catch (err: any) {
      showToast({
        type: 'error',
        text:
          err.message ??
          t({
            id: 'article.actions.start_article_exchange.error',
            message: 'An error occurred while starting article exchange. Please try again later.',
          }),
      });
    }
  };

  const exchangeStep = workflow?.nodes.find((node) => 'step' in node && node.step === 'exchange');

  return (
    <Footer>
      <FooterButtons>
        {exchangeStep?.config?.editExchangeDueDays?.enabled && (
          <>
            <ExchangeDuration />
            <ActionSeparator />
          </>
        )}
        <Button
          variant="primary"
          size="medium"
          onPress={() => {
            confirmStartExchange();
          }}
          isLoading={isStartExchangePending}
        >
          <Trans id="article.actions.start_article_exchange.validate">Start exchange</Trans>
        </Button>
      </FooterButtons>
    </Footer>
  );
};
